/* eslint-disable no-useless-escape */
export const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9](?:(?!-.*-)[A-Z0-9-])*[A-Z0-9]\.[A-Z]{2,}$/i;
// US-only: 10 digits (country code is implied as +1)
export const phoneRegex = /^\d{10}$/;
export const phoneFormat_usa = /^(\d{3})(\d{3})(\d{4})$/;
export const phoneFormat_other = /^(\d{2})(\d{3})(\d{3})(\d{3})$/;
export const websiteRegex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,63}(\/[a-zA-Z0-9\-._~:\/?#\[\]@!$&'()*+,;=]*)?$/;

export const isNumberFromString = (value: string): boolean => {
    return !Number.isNaN(Number(value));
};

export const phoneFormatHandler = (phoneNumberString: string) => {
    const usTenDigits = phoneNumberString.length === 11 && phoneNumberString.startsWith("1") ? phoneNumberString.slice(1) : phoneNumberString;

    let match = usTenDigits.match(phoneFormat_usa);
    if (match) {
        return "+1 (" + match[1] + ") " + match[2] + "-" + match[3];
    }
    match = usTenDigits.match(phoneFormat_other);
    if (match) {
        return "+" + match[1] + " (" + match[2] + ") " + match[3] + "-" + match[4];
    }

    return "Phone number not verified";
};
